module.exports = __webpack_public_path__ + "static/media/winner2.91424675.png";